<template>
  <div class="wisdom-project main">
    <div v-if="projectList.length > 0 && projectList" >
        <div class="project-part">
          <div class="project-item flex-layout csp" v-for="(item,index) in projectList" :key="index" @click="toDetail(item)">
              <div class="img-wrapper">
                <img :src="item.cover" alt="" class="project-cover">
              </div>
              <div class="info flex-column">
                  <h4 class="project-title">{{item.title}}</h4>
                  <p class="introduce wes-2">{{item.introduce}}</p>
                  <div class="summary flex-align-between">
                      <span class="time">
                          <i class="el-icon-date"></i>{{item.createTime.split(':').slice(0,2).join(':')}}</span>
                      <span class="views">
                          <i class="el-icon-view"></i>{{item.views}}</span>
                  </div>
              </div>
          </div>
        </div>
        <div class="pagination-part">
          <pagination v-show="pages.total > 0" 
                      :total="pages.total" 
                      :page.sync="pages.currentPage" 
                      :limit.sync="pages.pageSize"
                      :background="true"
                      @pagination="handlePageChange">
          </pagination>
        </div>
      </div>
      <!-- 无课节-->
      <div class="nothing-box flex-align" v-else>
        <div class="nothing-wrap">
          <img src="@/assets/wisdom/nothing.png" alt="">
          <p>暂无内容</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectList:[], //项目案例
      pages:{ //分页
        currentPage: 1,
        pageSize:5,
        total:0,
      },
      clazzMap:{
        90:4,
        109:5,
        110:6,
      }
    }
  },
  methods: {
    // 切换学科
    handleClick(item,index) {
      this.active = index;
      this.getProjectList();
    },
    // 切换分页
    handlePageChange(data){
      this.pages.currentPage = data.pageIndex
      this.pages.pageSize = data.pageSize
      this.getProjectList();
    },
    // 去详情页
    toDetail(item){
      this.$router.push(`/yunqiao/project/detail/${item.id}`)
    },
    // 获取项目列表
    async getProjectList() {
      let params = {
        clazz: this.clazzMap[Number(sessionStorage.getItem('projectID'))], //首师智研
        isAsc:'desc',
        pageNum: this.pages.currentPage,
        pageSize: this.pages.pageSize,
      }
      let resData = await Api.Wisdom.getProjectList(params)
      // console.log(resData);
      if(resData.rows);
      this.projectList = resData.rows;
      this.pages.total = resData.total;
    }
  },
  mounted() {
    this.getProjectList();
  }
}
</script>

<style lang="less" scoped>
  @import "./less/wisdom_subject.less";

</style>